import React, { useEffect, useState } from 'react';
import { Switch, Route, Router, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { createBrowserHistory } from 'history';
import 'react-perfect-scrollbar/dist/css/styles.css';

// Required to set up tokens
import './Auth';

import Auth from './pages/Auth';
import Dashboard from './pages/Dashboard';

import { syncUser } from './actions/UserActions';
import { isShareLink } from './helpers/helpers';
import { isLoggedIn } from './helpers/user_helpers';
import BetaInvite from './pages/auth/BetaInvite';
import TermsOfService from './pages/company/TermsOfService';

const browserHistory = createBrowserHistory();

const App = (props) => {
  const { user, syncUser } = props;
  const loggedIn = isLoggedIn(user);
  const [reduxLoaded, setLoaded] = useState(false);

  useEffect(() => {
    if (loggedIn) {
      const trackPageView = () => {
        window.__ADD_EVENT__('page', { path: window.location.pathname });
      };

      trackPageView(); // To track the first pageview upon load
      browserHistory.listen(trackPageView); // To track the subsequent pageviews
    }

    loggedIn && syncUser();
    setLoaded(true);
  }, [syncUser, loggedIn]);

  if (!reduxLoaded) return null;

  return (
    <Router history={browserHistory}>
      {loggedIn ? (
        <Switch>
          <Route render={() => <Dashboard />} exact path='/' />
          <Route render={() => <Dashboard />} exact path='/calls' />
          <Route render={() => <Dashboard />} exact path='/calls/:id' />
          <Route render={() => <Dashboard tab='upload' />} exact path='/upload' />
          <Route render={() => <Dashboard tab='chat' />} exact path='/chat' />
          <Route render={() => <Dashboard tab='forecast' />} exact path='/deals' />
          <Route render={() => <Dashboard tab='insights' />} exact path='/insights' />
          <Route render={() => <Dashboard tab='account' />} exact path='/account' />
          <Route render={() => <Dashboard />} exact path='/s/c/:hash' />
        </Switch>
      ) : isShareLink() ? (
        <Switch>
          <Route render={() => <Dashboard />} exact path='/s/c/:hash' />
        </Switch>
      ) : (
        <Switch>
          <Route render={() => <Auth />} exact path='/' />
          <Route component={() => <Auth />} exact path='/reset/:uid/:token' />

          <Route render={() => <BetaInvite />} exact path='/user/invite' />
          <Route render={() => <TermsOfService />} exact path='/company/terms-of-service' />
          <Redirect to='/' />
        </Switch>
      )}
    </Router>
  );
};

const mapStateToProps = (state) => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {
  syncUser,
})(App);
